import React from "react";
import Background from "@/components/Background";
import { Button } from "@/components/ui/button";
import { GoogleLogo } from "@phosphor-icons/react";

const Login = () => {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative">
      <Background />
      <div
        data-testid="login-card"
        className="glass rounded-3xl p-10 max-w-md w-full shadow-[0_20px_60px_rgba(0,0,0,0.35)]"
      >
        <div className="flex items-center gap-3 mb-8">
          <img
            src="/inspire-logo.png"
            alt="Inspire Education & Migration Services"
            className="w-14 h-14 object-contain"
          />
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Client CDB</p>
            <p className="font-heading font-semibold text-sm">Inspire Education & Migration</p>
          </div>
        </div>

        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mb-3">
          Welcome back.
        </h1>
        <p className="text-sm text-muted-foreground mb-8 leading-relaxed">
          Manage your clients reminders all in one space.
        </p>

        <Button
          data-testid="google-login-btn"
          onClick={handleLogin}
          className="w-full rounded-full h-12 gap-3 bg-white text-slate-900 hover:bg-slate-100 text-base"
        >
          <GoogleLogo weight="bold" size={20} />
          Continue with Google
        </Button>

        <p className="text-[11px] text-muted-foreground mt-8 text-center">
          Secured by Emergent Auth · Session valid for 7 days
        </p>
      </div>
    </div>
  );
};

export default Login;
